import {
  MANAGE_BRANCH_DOCUMENT,
  MANAGE_BRANCH_PAYMENT,
  MANAGE_BRANCH_TEAM,
} from "common/constants/permissionKeys";
import { usePermission } from "hooks/permission/usePermission";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

import { secretbox, randomBytes } from "tweetnacl";
import {
  decodeUTF8,
  encodeUTF8,
  encodeBase64,
  decodeBase64,
} from "tweetnacl-util";
export const allAreTrue = (arr) => {
  return arr.every((element) => element.value === true);
};

export const allAreFalse = (arr) => {
  return arr.every((element) => element.value === false);
};

export const formatPermissions = (permissions) => {
  const root = [];

  permissions = permissions.map((item, index) => {
    return { ...item, id: index + 1, all: "", value: false, sub: [] };
  });

  let mainArray = permissions;

  mainArray?.forEach((node) => {
    if (!node.parentId) return root.push(node);

    const parentIndex = mainArray?.findIndex(
      (el) => el.claimKey === node.parentId && el.type === node.type
    );
    if (parentIndex !== -1) {
      mainArray[parentIndex].sub.push(node);
    }
  });

  mainArray = mainArray.filter((item) => item.parentId === null);
  mainArray = mainArray.filter((item) => item.isVisible);

  return mainArray;
};

let arr = [];

const getPath = (model, id, path = []) => {
  if (!path) {
    path = [];
  }

  if (model == null) {
    return;
  }
  if (model.id === id) {
    arr = [...path];
  }
  if (model.sub) {
    model.sub?.forEach((child) => getPath(child, id, [...path, model.id]));
  }
};

const subRec = (event, model) => {
  model.value = event.target.checked;
  model.all = "";
  if (model?.sub?.length) {
    model.sub?.forEach((child) => {
      subRec(event, child);
    });
  }
};

const checkMidValue = (event, arr, model) => {
  if (arr.includes(model.id) && !event.target.checked) {
    model.all = "mid";
    model.value = true;
  } else if (arr.includes(model.id) && event.target.checked) {
    if (
      model.hasOwnProperty("sub") &&
      !allAreTrue(model.sub) &&
      !allAreFalse(model.sub)
    ) {
      model.all = "mid";
    }
  }

  if (model.hasOwnProperty("sub"))
    model.sub?.forEach((child) => checkMidValue(event, arr, child));
};

const recursiveCheckForDependancy = (item, event, dependancy = []) => {
  if (dependancy && dependancy.length) {
    if (dependancy.includes(item.claimKey)) {
      item.value = event.target.checked;
    }
    if (item.hasOwnProperty("sub")) {
      item.sub.forEach((subItem) => {
        recursiveCheckForDependancy(subItem, event, dependancy);
      });
    }
    return;
  } else return;
};
const newRecurrsion = (event, arr, model, bkId) => {
  if (arr.includes(model.id)) {
    if (event.target.checked) {
      model.value = event.target.checked;
      model.all = "";
    }

    if (model.id === bkId) subRec(event, model);
  }
  if (model.sub)
    model.sub?.forEach((child) => newRecurrsion(event, arr, child, bkId));
};

const checkSiblingsFalse = (parent) => {
  if (parent.hasOwnProperty("sub")) {
    return parent.sub.every((item) => !item.value);
  }
  return false;
};

const claimsStatusAnalyse = (array) => {
  let status = "";
  if (array.every((elem) => elem.value && !elem.all)) {
    return status;
  }
  if (array.some((elem) => elem.value)) {
    status = "mid";
    return status;
  }
  return status;
};

export const claimsAnalyse = (permissionsList) => {
  for (let i = 0; i < permissionsList.length; i++) {
    let elementI = permissionsList[i];
    if (elementI.hasOwnProperty("sub")) {
      claimsAnalyse(elementI["sub"]);
      let status = claimsStatusAnalyse(elementI["sub"]);
      elementI.all = status;
    }
  }
  return permissionsList;
};

export const handleClaimsParentLevel = (event, item, permissionsList) => {
  let temp = permissionsList;

  for (let i = 0; i < temp.length; i++) {
    const elementI = temp[i];

    getPath(elementI, item.id);
  }
  arr = [...arr, item?.id];
  permissionsList.forEach((newItem) => {
    recursiveCheckForDependancy(newItem, event, item?.dependentPermissions);
  });
  permissionsList.forEach((newItem) => {
    newRecurrsion(event, arr, newItem, item.id);
  });
  arr.pop();
  permissionsList.forEach((newItem) => {
    if (newItem.hasOwnProperty("sub")) checkMidValue(event, arr, newItem);
  });

  return permissionsList;
};

const findParentNode = (id, object) => {
  let temp = null;
  if (id === object.id) {
    if (checkSiblingsFalse(object)) {
      object.all = "";
      object.value = false;
    }
    return object;
  }

  if (object.hasOwnProperty("sub")) {
    object.sub?.forEach((ele) => {
      findParentNode(id, ele);
    });
  }
};

export const getRoleFromLocalStorage = () => {
  let role = localStorage.getItem("userRole");

  role = JSON.parse(role).roleName;

  return role;
};

export const checkRole = () => {
  const role = JSON.parse(localStorage.getItem("userRole"));
  return role?.roleName;
};

export const camalize = function camalize(str) {
  return str
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr.toUpperCase());
};
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const germanMonths = [
  "Januar",
  "Februar",
  "März",
  "April",
  "Mai",
  "Juni",
  "Juli",
  "August",
  "September",
  "Oktober",
  "November",
  "Dezember",
];
export const localizeGraphData = (data) => {
  let graphData = data?.map((item, index) => {
    item.x = i18next.language == "de" ? replaceMonthNames(item.x) : item.x;
    return item;
  });
  return graphData;
};
const replaceMonthNames = (str) => {
  for (let i = 0; i < months.length; i++) {
    const regex = new RegExp(months[i], "g");
    str = str.replace(regex, germanMonths[i]);
  }
  return str;
};
export const productMenus = () => {
  const { t } = useTranslation();
  const { checkPermission } = usePermission();
  return {
    gecco:
      checkRole() === "#EA"
        ? [
            {
              lable: t("add-payment"),
              path: "Add Payment",
              navigateTo: "payment-info",
              isPermission: checkPermission(MANAGE_BRANCH_PAYMENT)
                ? true
                : false,
            },
            {
              lable: t("upload-documents"),
              path: "Upload Document",
              navigateTo: "upload-document",
              isPermission: checkPermission(MANAGE_BRANCH_DOCUMENT)
                ? true
                : false,
            },
          ]
        : [],
    futurecare: [
      {
        lable: t("create-teams"),
        path: "Create Team",
        navigateTo: "teams",
        isPermission: checkPermission(MANAGE_BRANCH_TEAM) ? true : false,
      },
      {
        lable: t("upload-documents"),
        path: "Upload Document",
        navigateTo: "upload-document",
        isPermission: checkPermission(MANAGE_BRANCH_DOCUMENT) ? true : false,
      },
    ],
    esg: [],
  };
};
export const getCurrentDate = () => {
  const currentDate = new Date();
  const options = { day: "2-digit", month: "2-digit", year: "numeric" };
  return currentDate.toLocaleDateString("en-GB", options).replace(/\//g, "-");
};
const newNonce = () => randomBytes(secretbox.nonceLength);
export const encrypt = (json, key) => {
  const keyUint8Array = decodeBase64(key);

  const nonce = newNonce();
  const messageUint8 = decodeUTF8(JSON.stringify(json));
  const box = secretbox(messageUint8, nonce, keyUint8Array);

  const fullMessage = new Uint8Array(nonce.length + box.length);
  fullMessage.set(nonce);
  fullMessage.set(box, nonce.length);

  const base64FullMessage = encodeBase64(fullMessage);
  return base64FullMessage;
};
export const dateParser = (dateTime) => {
  // Create a Date object
  const date = new Date(dateTime);

  // Format as dd.mm.yyyy
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
};
